import api from './axios';

export const listPedidos = (filtros = {}) => api.get('/pedidos/', { params: filtros });
export const getPedido = (id) => api.get(`/pedidos/${id}`);
export const createPedido = (data) => api.post('/pedidos/', data);
export const updatePedido = (id, data) => api.patch(`/pedidos/${id}`, data);
export const confirmarPedido = (id) => api.post(`/pedidos/${id}/confirmar`);
export const cancelarPedido = (id) => api.post(`/pedidos/${id}/cancelar`);
